import { render, staticRenderFns } from "./AssignUserInvitation.vue?vue&type=template&id=219ad9c9&scoped=true&"
import script from "./AssignUserInvitation.vue?vue&type=script&lang=js&"
export * from "./AssignUserInvitation.vue?vue&type=script&lang=js&"
import style0 from "./AssignUserInvitation.vue?vue&type=style&index=0&id=219ad9c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219ad9c9",
  null
  
)

export default component.exports